






















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import * as fileStorage from "@/domain/fileStorage";
import * as util from "@/util";

@Component
export default class AvatarRef extends Vue {
  @Prop({ required: true }) fileRef!: string;
  @Prop({ default: 1 }) aspectRatio!: string;
  @Prop({ default: "" }) height!: string;
  @Prop({ default: "" }) maxWidth!: string;
  @Prop({ default: "" }) maxHeight!: string;

  file = fileStorage.newFileRef("");

  get needsToLoad(): boolean {
    return this.fileRef !== this.file.ref || (!!this.file.ref && !this.file.url && !this.file.loading);
  }

  @Watch("fileRef")
  onChange() {
    this.refresh();
  }

  refresh() {
    if (this.needsToLoad) {
      this.file = fileStorage.newFileRef(this.fileRef);
      util.promiseEnd(fileStorage.resolveFile(this.file));
    }
  }

  created() {
    this.refresh();
  }
}
